import { AnyAsyncThunk, UnknownAsyncThunkRejectedAction } from '@reduxjs/toolkit/dist/matchers';
import { selectToken } from 'core/selectors/product/token';
import { createRequest, updateRequest } from 'core/services/admin';
import { errorRequest, moduleRequest, tokenRequest } from 'core/services/product';
import { IToken, setError, updateTokenState } from 'core/slices/session';
import { eventChannel } from 'redux-saga';
import { all, call, fork, take, put, takeEvery, select } from 'redux-saga/effects';
import { RootState } from 'types';
import { IError } from 'types/app/error';
import { LoadingState } from 'types/domain/base';
import rg4js from 'raygun4js';

function* init() {
  if (process.env.NODE_ENV === 'development') return;

  // rg4js('apiKey', '6SiPoXoTgGVDWdoZomiw');
  // rg4js('enableCrashReporting', true);

  const errorEvent = yield call(errorChannel);
  let waiting = true;

  while (waiting) {
    const error = yield take(errorEvent);
    const message = yield select((state: RootState) => state.session.error?.message);
    waiting = !message;
    yield put(yield call(setError, { code: 0, message: error.message, stackTrace: 'unknown' } as IError));
    try {
      yield put(yield call(errorRequest, { code: 0, message: error.message, stackTrace: 'unknown' } as IError));
    } catch (e) {
    }
  }
}

function* rejectionSaga(action: any) {
  yield put(
    yield call(setError, {
      code: 0,
      message: `There was a problem with the last save - ${action.error.message}`,
      stackTrace: 'unknown',
    } as IError),
  );
}

function* failedLoadsSaga(action: UnknownAsyncThunkRejectedAction) {
  const error = yield call([JSON, JSON.stringify], action);

  yield put(
    yield call(errorRequest, {
      code: 0,
      message: action.error
        ? `load error: type:${action.type} code:${action.error.code} name:${action.error.name} message:${action.error.message}`
        : `load error: type:${action.type}`,
      stackTrace: error,
    } as IError),
  );

  const token: IToken = yield select(selectToken);

  if (token)
    yield put(
      yield call(updateTokenState, {
        token: token.token,
        loading: LoadingState.ERROR,
        message: `Loading failed - ${action.error?.message}`,
      }),
    );
}

function* watchRejections() {
  yield takeEvery([updateRequest.rejected, createRequest.rejected], rejectionSaga);
}

function* watchFailedLoads() {
  yield takeEvery([moduleRequest.rejected, tokenRequest.rejected], failedLoadsSaga);
}

export default function* errorSaga() {
  yield all([fork(init), fork(watchRejections), fork(watchFailedLoads)]);
}

function errorChannel() {
  return eventChannel(emitter => {
    window.addEventListener('error', emitter);
    return () => window.removeEventListener('error', emitter);
  });
}
